<template>
    <div>
        <div>
            <div class="row p-3">
                <input-select label="Projeção financeira" :options="projecoes" v-model="form.projecaoFinanceiraId" class="col-12 col-md-8">
                    <template #append>
                        <b-button class="ml-2" @click="adicionarProjecao" variant="info">
                            <i class="fas fa-plus mr-2"></i>
                            Adicionar projeção
                        </b-button>
                    </template>
                </input-select>
                <div class="col-12 col-md-4">
                    <b-badge class="mb-2">Saldo da projeção</b-badge>
                    <h3>R$ 0,00</h3>
                </div>
            </div>
        </div>
        <div>
            <b-form>
                <b-table-simple hover small borderless table-variant="tab" >
                <b-thead head-variant="tab">
                    <b-tr>
                        <b-th colspan="7" style="border-left: none; border-right: none;">Estimativa de custos</b-th>
                    </b-tr>
                    <b-tr>
                        <b-th rowspan="2" style="border-left: none;"></b-th>
                        <b-th rowspan="2">Sigla</b-th>
                        <b-th rowspan="2">Fase</b-th>
                        <b-th rowspan="2">Valor</b-th>
                        <b-th colspan="2">Tempo</b-th>
                        <b-th rowspan="2" style="border-right: none;">Quantidade de projetos</b-th>
                    </b-tr>
                    <b-tr>
                        <b-th>Inicio</b-th>
                        <b-th>Fim</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="estimativa in form.estimativas" :key="estimativa.id">
                        <b-td style="border-left: none;">
                            <i v-if="form.estimativas.length > 1 && !disabled" class="fas fa-trash text-danger cursor" @click="removeEstimativa(estimativa)"></i>
                        </b-td>
                        <b-td>{{(estimativa.fase ? fases.find(el => el.value == estimativa.fase).sigla : '')}}</b-td>
                        <b-td class="table-tab__input">
                            <input-select :disabled="disabled" no-label label="Fase" :options="fases" v-model="estimativa.fase" ref="fases" required />
                        </b-td>
                        <b-td class="table-tab__input">
                            <input-money :disabled="disabled" no-label label="Valor" v-model="estimativa.valor" ref="valor" required   />
                        </b-td>
                        <b-td class="table-tab__input">
                            <input-date-time :disabled="disabled" no-label label="Data inicial" v-model="estimativa.inicio" ref="dataInicio" required  />
                        </b-td>
                        <b-td class="table-tab__input">
                            <input-date-time :disabled="disabled" no-label label="Data final" v-model="estimativa.fim" ref="dataFim" required />
                        </b-td>
                        <b-td class="table-tab__input"  style="border-right: none;">
                            <input-text :disabled="disabled" no-label label="Quantidade"  v-model="estimativa.quantidadeProjetos" type="number" @enter="addRow" ref="quantidadeProjetos" required />
                        </b-td>                        
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            </b-form>
        </div>
        <div class="px-3">
            <div class="row px-3 pb-3 ">
                <div class="col-12 d-flex justify-content-end">
                    <b-button variant="success" v-if="!disabled" @click="$emit('save')">
                        <i class="fa-solid fa-check mr-2"></i>
                        Salvar planejamento
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InputDateTime from "@/components/inputs/InputDateTime";
import InputSelect from "@/components/inputs/InputSelect";
import InputMoney from "@/components/inputs/InputMoney";
import InputText from "@/components/inputs/InputText";
import ProjecaoFinanceira from "@/common/services/projecao_financeira/projecao_financeira.service";
export default {
    name: "PlanejamentoEstimativa",
    props:{
        disabled: {
            type: Boolean,
            default: false
        },
        form: {
            type: Object,
            default: () => ({
                estimativas : []
            })
        },
    },
    components: {
        InputDateTime,
        InputSelect,
        InputMoney,
        InputText
    },
    mounted(){
        this.buscarProjecoes();
    },  
    data: () => ({
        fases : [
            {
                value : 'PesquisaBasica',
                text : "Pesquisa básica",
                sigla : "PB"
            },
            {
                value : 'PesquisaAplicada',
                text : "Pesquisa aplicada",
                sigla : "PA"
            },
            {
                value : 'DesenvolvimentoExperimental',
                text : "Desenvolvimento experimental",
                sigla : "DE"
            },
            {
                value : 'CabecaDeSerie',
                text : "Cabeça de série",
                sigla : "CS"
            },
            {
                value : 'LotePioneiro',
                text : "Lote pioneiro",
                sigla : "LP"
            },
            {
                value : 'InsercaoNoMercado ',
                text : "Inserção no mercado",
                sigla : "IM"
            }
        ],
        projecoes : []
    }),
    methods : {
        adicionarProjecao(){
            this.$router.push({ name: "projecao-financeira" });
        },
        buscarProjecoes(){
            ProjecaoFinanceira.selecao(this.empresaSelecionada).then(res => {
                this.projecoes = res.data.data.map(el => {
                    return {
                        value : el.id,
                        text : el.nome
                    }
                });
            })
        },
        validateState: function() {
            let arValidation = [];

            for (let ref in this.$refs) {
                if(this.$refs[ref].length == undefined){
                    arValidation.push(this.$refs[ref].valid());
                }else{
                    for(let i = 0; i < this.$refs[ref].length; i++){
                        arValidation.push(this.$refs[ref][i].valid());
                    }
                }
            }
           
            return arValidation.filter((elem) => elem == false).length == 0;
        },
        addRow : function(){
            if(!this.validateState())
                return false;

            this.form.estimativas.push({
                id : null,
                fase: null,
                valor: 0,
                tempo :{
                    inicio: null,
                    fim: null,
                },
                quantidadeProjetos : 0
            });
        },
        removeEstimativa: function(estimativa){
            this.form.estimativas.splice(this.form.estimativas.indexOf(estimativa), 1);
        }
    },
    computed : {
        empresaSelecionada: function(){
            return this.$store.state.app.selectedCompanyObj ? this.$store.state.app.selectedCompanyObj.id : null;
        },
    }
    
    
}
</script>
<style>
    .cursor{
        cursor: pointer;
    }
</style>